import AccountOwnerAttributes from '@engine/features/virtual_terminal/vt_account_owner_attributes';
import BankPayout from '@engine/features/virtual_terminal/vt_update_bank_payout_fields';
import BaseMobileInitRecurring from '@engine/features/virtual_terminal/vt_base_mobile_init_recurring';
import BusinessAttributes from '@engine/features/virtual_terminal/vt_business_attributes';
import Cash from '@engine/features/virtual_terminal/vt_update_cash_fields';
import Change from '@engine/features/virtual_terminal/vt_terminal_change';
import CitadelPayout from '@engine/features/virtual_terminal/vt_update_citadel_attributes';
import CountriesWithDocumentId from '@engine/features/virtual_terminal/vt_countries_with_document_id_change';
import Entercash from '@engine/features/virtual_terminal/vt_entercash';
import FxRates from '@engine/features/virtual_terminal/vt_fx_rates';
import Inpay from '@engine/features/virtual_terminal/vt_inpay';
import Invoice from '@engine/features/virtual_terminal/vt_transaction_items';
import MoneyTransfer from '@engine/features/virtual_terminal/vt_money_transfer_type_change';
import NonReferencedRecurring from '@engine/features/virtual_terminal/vt_non_referenced_recurring';
import OnlineBanking from '@engine/features/virtual_terminal/vt_update_online_banking_fields';
import OptionalFields from '@engine/features/virtual_terminal/vt_update_optional_fields';
import PayByLink from '@engine/features/virtual_terminal/vt_update_pay_by_link';
import PayByLinkBankCodes from '@engine/features/virtual_terminal/vt_update_pay_by_link_bank_codes';
import PayByLinkConsumers from '@engine/features/virtual_terminal/vt_update_pay_by_link_consumers';
import PayByLinkPaymentTypes from '@engine/features/virtual_terminal/vt_update_pay_by_link_payment_types';
import PayByLinkRecurringTypes from '@engine/features/virtual_terminal/vt_update_pay_by_link_recurring_types';
import Ppro from '@engine/features/virtual_terminal/vt_update_ppro_fields';
import PreconfiguredUrls from '@engine/features/virtual_terminal/vt_preconfigured_urls';
import RemainingAmount from '@engine/features/virtual_terminal/vt_remaining_amount';
import RequiredFields from '@engine/features/virtual_terminal/vt_update_required_fields';
import ShippingAddress from '@engine/features/virtual_terminal/vt_shipping_support';
import SupportedCountries from '@engine/features/virtual_terminal/vt_supported_countries';
import TransferTo from '@engine/features/virtual_terminal/vt_transfer_to_requirements';
import Travel from '@engine/features/virtual_terminal/vt_travel';
import Webmoney from '@engine/features/virtual_terminal/vt_webmoney';
var VirtualTerminal = {
  BusinessAttributes: BusinessAttributes,
  Change: Change,
  RequiredFields: RequiredFields,
  OptionalFields: OptionalFields,
  PayByLink: PayByLink,
  PayByLinkConsumers: PayByLinkConsumers,
  RemainingAmount: RemainingAmount,
  Entercash: Entercash,
  ShippingAddress: ShippingAddress,
  SupportedCountries: SupportedCountries,
  Invoice: Invoice,
  OnlineBanking: OnlineBanking,
  Cash: Cash,
  BankPayout: BankPayout,
  CitadelPayout: CitadelPayout,
  Inpay: Inpay,
  Webmoney: Webmoney,
  Ppro: Ppro,
  MoneyTransfer: MoneyTransfer,
  Travel: Travel,
  CountriesWithDocumentId: CountriesWithDocumentId,
  TransferTo: TransferTo,
  FxRates: FxRates,
  PreconfiguredUrls: PreconfiguredUrls,
  PayByLinkPaymentTypes: PayByLinkPaymentTypes,
  PayByLinkBankCodes: PayByLinkBankCodes,
  BaseMobileInitRecurring: BaseMobileInitRecurring,
  PayByLinkRecurringTypes: PayByLinkRecurringTypes,
  AccountOwnerAttributes: AccountOwnerAttributes,
  NonReferencedRecurring: NonReferencedRecurring
};
export default VirtualTerminal;